import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { delay } from 'rxjs/operators';

import { IProcessingResultsService } from '../../interfaces/services/processing-results-service.interface';

import {

  ProcessingResult,

  ProcessingResultsPage,

  ProcessingResultsQuery,

} from '../../interfaces/state/entities/processing-result.interface';

import {

  CaptureProcessingResultDetail,

  DrawingProcessingResultDetail,

} from '../../interfaces/state/entities/processing-result-detail.interface';



const PAGE_SIZE = 5;



const DRAWING_DETAIL: DrawingProcessingResultDetail = {

  extraction: {

    drawingId: 'd-1001',

    createdAt: '2026-06-18T15:59:06Z',

    floorName: 'Ground Floor',

    revisionNumber: 3,

    externalId: 'ext-drawing-001',

  },

  processing: {

    processId: '744624f1-6b3f-4055-9402-4cd4a5b23ca8',

    createdAt: '2026-06-18T15:59:06Z',

    status: 'Processed',

    externalId: 'ext-process-001',

    failureReason: '',

    processedAt: '2026-06-18T16:03:42Z',

  },

  output: {

    drawingWidth: 4096,

    drawingHeight: 3072,

    scaleFactor: 0.125,

    rotation: 90,

    downloadFloorplanUrl: 'https://localhost/storage/floorplans/ground-floor-rev3.png',

  },

};



const CAPTURE_DETAIL: CaptureProcessingResultDetail = {
  extraction: {
    captureId: 'cap-2001',
    createdAt: '2026-06-10T11:20:00Z',
    floorId: 'floor-100',
    drawingId: 'd-2001',
    sessionId: 'sess-9001',
    capturedAt: '2026-06-10T11:18:30Z',
    fileType: 'mp4',
    location: { x: 12.5, y: 0, z: -3.2 },
    position: { direction: 'north', rotation: 45 },
    previousId: 'cap-1999',
    externalId: 'ext-capture-001',
  },
  processing: {
    processId: 'cap-proc-001',
    createdAt: '2026-06-10T11:20:00Z',
    status: 'Processed',
    externalId: 'ext-process-cap-001',
    failureReason: '',
    processedAt: '2026-06-10T11:25:12Z',
  },
  output: {
    video: { stationCount: 8 },
    orientation: {
      processedAt: '2026-06-10T11:24:00Z',
      heading: 127,
    },
    privacy: {
      processedAt: '2026-06-10T11:24:45Z',
      filePrefix: 'sess-9001_privacy',
    },
  },
};



@Injectable({ providedIn: 'root' })

export class ProcessingResultsMockService implements IProcessingResultsService {

  private readonly dataByProject: Record<string, ProcessingResult[]> = {

    '1': [

      {

        processId: '744624f1-6b3f-4055-9402-4cd4a5b23ca8',

        createdAt: new Date('2026-06-18T15:59:06Z'),

        processType: 'Drawing',

        status: 'Processed',

        processedAt: new Date('2026-06-18T16:03:42Z'),

      },

      {

        processId: 'fae9f763-6c9f-4116-af6d-d71d0948afb6',

        createdAt: new Date('2026-06-18T13:50:34Z'),

        processType: 'Drawing',

        status: 'Processed',

        processedAt: new Date('2026-06-18T13:54:24Z'),

      },

      {

        processId: 'cap-proc-001',

        createdAt: new Date('2026-06-10T11:20:00Z'),

        processType: 'Capture',

        status: 'Processed',

        processedAt: new Date('2026-06-10T11:25:12Z'),

      },

      {
        processId: 'be96a90f-ace7-4d04-a2b6-a88cc6e98768',
        createdAt: new Date('2026-05-06T13:26:43Z'),
        processType: 'Drawing',
        status: 'Processed',
        processedAt: new Date('2026-05-06T13:30:11Z'),
      },
      {
        processId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
        createdAt: new Date('2026-04-22T09:15:00Z'),
        processType: 'Drawing',
        status: 'Failed',
        processedAt: new Date('2026-04-22T09:20:33Z'),
      },
      {
        processId: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
        createdAt: new Date('2026-04-15T14:30:00Z'),
        processType: 'Capture',
        status: 'Processed',
        processedAt: new Date('2026-04-15T14:38:12Z'),
      },
      {
        processId: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
        createdAt: new Date('2026-03-28T11:00:00Z'),
        processType: 'Drawing',
        status: 'Uploaded',
        processedAt: null,
      },
      {
        processId: 'd4e5f6a7-b8c9-0123-def0-234567890123',
        createdAt: new Date('2026-03-10T16:45:00Z'),
        processType: 'Drawing',
        status: 'Processed',
        processedAt: new Date('2026-03-10T16:52:18Z'),
      },
      {
        processId: 'e5f6a7b8-c9d0-1234-ef01-345678901234',
        createdAt: new Date('2026-02-20T08:20:00Z'),
        processType: 'Capture',
        status: 'Pending',
        processedAt: null,
      },
      {
        processId: 'f6a7b8c9-d0e1-2345-f012-456789012345',
        createdAt: new Date('2026-02-05T13:10:00Z'),
        processType: 'Drawing',
        status: 'Processed',
        processedAt: new Date('2026-02-05T13:17:45Z'),
      },
      {
        processId: 'a7b8c9d0-e1f2-3456-0123-567890123456',
        createdAt: new Date('2026-01-18T10:30:00Z'),
        processType: 'Capture',
        status: 'Failed',
        processedAt: new Date('2026-01-18T10:35:22Z'),
      },
      {
        processId: 'b8c9d0e1-f2a3-4567-1234-678901234567',
        createdAt: new Date('2026-01-02T15:00:00Z'),
        processType: 'Drawing',
        status: 'Processed',
        processedAt: new Date('2026-01-02T15:08:09Z'),
      },
      {
        processId: 'c9d0e1f2-a3b4-5678-2345-789012345678',
        createdAt: new Date('2025-12-15T09:45:00Z'),
        processType: 'Drawing',
        status: 'Active',
        processedAt: null,
      },
      {
        processId: 'd0e1f2a3-b4c5-6789-3456-890123456789',
        createdAt: new Date('2025-12-01T12:20:00Z'),
        processType: 'Capture',
        status: 'Processed',
        processedAt: new Date('2025-12-01T12:28:51Z'),
      },
      {
        processId: 'e1f2a3b4-c5d6-7890-4567-901234567890',
        createdAt: new Date('2025-11-20T07:55:00Z'),
        processType: 'Drawing',
        status: 'Processed',
        processedAt: new Date('2025-11-20T08:03:14Z'),
      },
    ],

  };



  getProcessingResults(query: ProcessingResultsQuery): Observable<ProcessingResultsPage> {

    const all = this.dataByProject[query.projectId] ?? [];

    const startIndex = query.bookmark ? Number.parseInt(query.bookmark, 10) : 0;

    const slice = all.slice(startIndex, startIndex + PAGE_SIZE);

    const nextIndex = startIndex + PAGE_SIZE;

    const hasMoreData = nextIndex < all.length;



    return of({

      items: slice,

      continuation: {

        hasMoreData,

        bookmark: hasMoreData ? String(nextIndex) : undefined,

      },

    }).pipe(delay(100));

  }



  getDrawingProcessingResult(_processId: string): Observable<DrawingProcessingResultDetail> {

    return of(DRAWING_DETAIL).pipe(delay(150));

  }



  getCaptureProcessingResult(_processId: string): Observable<CaptureProcessingResultDetail> {

    return of(CAPTURE_DETAIL).pipe(delay(150));

  }

}


